export default "__VITE_ASSET__2UDAeMfp__"